import { Component } from "react";
import "./OptionsMenu.scss";
//Icons
import GridOnIcon from "@material-ui/icons/GridOn";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import OpenWithIcon from "@material-ui/icons/OpenWith";
import SelectAllIcon from "@material-ui/icons/SelectAll";
// import InfoIcon from "@material-ui/icons/Info";
import HelpIcon from "@material-ui/icons/Help";
import NotesIcon from "@material-ui/icons/Notes";
import PanToolIcon from "@material-ui/icons/PanTool";
import RedoIcon from "@material-ui/icons/Redo";
import UndoIcon from "@material-ui/icons/Undo";
import SettingsIcon from "@material-ui/icons/Settings";
import Tooltip from "@mui/material/Tooltip";
import cx from "classnames";
import { Vector2d } from "konva/lib/types";
import { StatusTokenType } from "./constants/card-constants";
import { GameType } from "./game-modules/GameType";

interface IProps {
  anyCardsSelected: boolean;
  currentGameType: GameType | null;
  panMode: boolean;
  multiselectMode: boolean;
  drawCardsIntoHand: boolean;
  snapCardsToGrid: boolean;
  notesVisible: boolean;
  togglePanMode: () => void;
  toggleNotes: () => void;
  toggleMultiselectMode: () => void;
  flipCards: () => void;
  exhaustAllCards: (id?: string) => void;
  toggleToken: (payload: {
    id?: string;
    tokenType: StatusTokenType;
    value?: boolean;
  }) => void;
  shuffleStack: (id?: string) => void;
  showRadialMenuAtPosition: (payload: Vector2d) => void;
  showContextMenuAtPosition: (payload: Vector2d) => void;
  undo: () => void;
  redo: () => void;
  toggleDrawCardsIntoHand: () => void;
  toggleSnapCardsToGrid: () => void;
  showSettingsUi: () => void;
}
class OptionsMenu extends Component<IProps> {
  static whyDidYouRender = false;
  render() {
    return (
      <div className="options-menu">
        <button
          onClick={() => {
            this.props.showContextMenuAtPosition({ x: 0, y: 0 });
          }}
        >
          <MoreVertIcon fontSize="large" />
        </button>
        <Tooltip title="Toggle Pan Mode">
          <button
            className={cx({ "toggle-on": this.props.panMode })}
            onClick={() => {
              this.props.togglePanMode();
            }}
          >
            <OpenWithIcon fontSize="large" />
          </button>
        </Tooltip>
        <Tooltip title="Toggle Draw Cards into Hand">
          <button
            className={cx({ "toggle-on": this.props.drawCardsIntoHand })}
            onClick={() => {
              this.props.toggleDrawCardsIntoHand();
            }}
          >
            <PanToolIcon fontSize="large" />
          </button>
        </Tooltip>
        <Tooltip title="Toggle Snap To Grid">
          <button
            className={cx({ "toggle-on": this.props.snapCardsToGrid })}
            onClick={() => {
              this.props.toggleSnapCardsToGrid();
            }}
          >
            <GridOnIcon fontSize="large" />
          </button>
        </Tooltip>
        <button
          className={cx("render-touch-only", {
            "toggle-on": this.props.multiselectMode,
          })}
          onClick={() => {
            this.props.toggleMultiselectMode();
          }}
        >
          <SelectAllIcon fontSize="large" />
        </button>
        {/* <button
          className={"render-touch-only"}
          onClick={() => {
            if (this.props.anyCardsSelected) {
              this.props.showRadialMenuAtPosition({
                x: 64,
                y: (window.visualViewport as VisualViewport).height / 2,
              });
            }
          }}
        >
          <InfoIcon fontSize="large" />
        </button> */}
        <Tooltip title="Toggle Notes">
          <button
            className={cx({ "toggle-on": this.props.notesVisible })}
            onClick={() => {
              if (this.props.toggleNotes) {
                this.props.toggleNotes();
              }
            }}
          >
            <NotesIcon fontSize="large" />
          </button>
        </Tooltip>
        <Tooltip title="Undo">
          <button
            onClick={() => {
              if (this.props.undo) {
                this.props.undo();
              }
            }}
          >
            <UndoIcon fontSize="large" />
          </button>
        </Tooltip>
        <Tooltip title="Redo">
          <button
            onClick={() => {
              if (this.props.redo) {
                this.props.redo();
              }
            }}
          >
            <RedoIcon fontSize="large" />
          </button>
        </Tooltip>
        <Tooltip title="Help">
          <button
            onClick={() => {
              window.open(
                "https://erlloyd.github.io/cardtable-docs/",
                "_blank",
                "noreferrer"
              );
            }}
          >
            <HelpIcon fontSize="large" />
          </button>
        </Tooltip>
        <Tooltip title="Settings">
          <button
            onClick={() => {
              this.props.showSettingsUi();
            }}
          >
            <SettingsIcon fontSize="large" />
          </button>
        </Tooltip>
      </div>
    );
  }
}

export default OptionsMenu;
